export default __webpack_public_path__ + "static/media/fusion-32h.4ee3dbc4.svg";